export const APP_MESSAGES: { [key: string]: string } = {
  DEPOSIT:
    'Confirmed! Your [AMOUNT] has been successfully deposited into your wallet.',
  WITHDRAW:
    'The transaction for the withdraw ended. Please check the wallet transaction history.',
  ADMIN_DEPOSIT:
    'There are new transactions. Please check the wallet transaction history.',
  ADMIN_WITHDRAW:
    'There are new transactions. Please check the wallet transaction history.',
  ADMIN_APPROVED_WITHDRAW:
    'Your withdrawal request has been approved. Check the Z-Wallet transaction history to finalize the process.',
  ADMIN_DECLINED_WITHDRAW:
    'Your withdrawal request was declined. Please check your Transaction History to see other details.',
  WITHDRAW_FEE_FAILS:
    'Your withdrawal request cannot be processed as you do not have enough tokens to process the transaction fee. Your withdrawal request amount will be refunded in your Z-token wallet.',
  PLAY_INSTANCE_FINALIZED: 'Your game results were processed successful.',
  PLAY_INSTANCE_FINALIZED_ENEMY:
    'Will update the game result with other players information.',
  PROCESS_TRANSACTION:
    'We are processing your transaction, it could take a few minutes.',
  WALLET_FROZEN_BY_ADMIN:
    'Apologies, your wallet was frozen and we cannot allow you to continue. Please reach out to customer support as soon as possible.',
  WALLET_FROZEN_BY_TAX_INFORMATION_REQUIRED:
    'Apologies, your wallet is frozen because we need you to update your tax profile. This is required by law.',
  CUSTOMER_REGISTRATION_TIMEOUT:
    'You have exceeded the maximum time allowed to complete the verification process. Please try again.',
  DEPOSIT_TIMEOUT:
    'The deposit process timed out. Please try again by confirming a new deposit.',
  DOCUMENT_VERIFICATION_APPROVED:
    'Your player profile is completed and verified. You’re all set to start playing in our paid tournaments. Start having fun!',
  VERIFICATION_REJECTED:
    'Sorry, but we couldn’t verify your player profile. Please contact customer service for further assistance.',
};
